module.exports = __webpack_public_path__ + "static/media/Salimata_desktop_article_7.77150188.jpg";